module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-user me-3"
  }, [(_vm.registrationText) ? _c('div', {
    staticClass: "header-user__signup"
  }, [_c('SignLink', {
    staticClass: "header-user__link",
    attrs: {
      "to": _vm.registrationLink
    },
    on: {
      "click": _vm.pushToRegister
    }
  }, [_vm._v(_vm._s(_vm.registrationText))])], 1) : _vm._e(), _c('div', {
    staticClass: "header-user__signin"
  }, [_c('SignLink', {
    attrs: {
      "to": _vm.entranceLink
    },
    on: {
      "click": _vm.pushToSignIn
    }
  }, [_vm._v(_vm._s(_vm.entranceText))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73369268","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/header/User.vue
// module id = 0cfdfbcba258d5a55162
// module chunks = 8